import React from 'react';

function SectionLabel({ label, count }) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-[11px] font-['Unbounded'] font-semibold uppercase tracking-[0.16em] text-white/75 whitespace-nowrap">
        {label}
      </span>
      <span className="h-px flex-1 bg-gradient-to-r from-white/20 to-transparent" />
      <span className="text-[10px] font-['Manrope'] text-white/40 tabular-nums whitespace-nowrap">
        {count}
      </span>
    </div>
  );
}

export default function DateSectionHeader({ label, count, colSpan = 6, compact = false, variant = 'table' }) {
  const testId = `date-section-${label.toLowerCase().replace(/\s+/g, '-')}`;
  if (variant === 'list') {
    return (
      <div className="px-1 py-2" data-testid={testId}>
        <SectionLabel label={label} count={count} />
      </div>
    );
  }
  return (
    <tr className="bg-white/[0.045]" data-testid={testId}>
      <td colSpan={colSpan} className={compact ? 'px-4 py-2' : 'px-6 py-2.5'}>
        <SectionLabel label={label} count={count} />
      </td>
    </tr>
  );
}
